import { render, staticRenderFns } from "./TheInvitationPage.vue?vue&type=template&id=917a6800"
import script from "./TheInvitationPage.vue?vue&type=script&lang=js"
export * from "./TheInvitationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports